/**
 * Para çekmecesi tetik yazıcısı localStorage persistence util.
 *
 * Bu ayar BİLGİSAYARA ÖZEL olduğu için SQL'e değil, yalnızca tarayıcı
 * localStorage'ına yazılır ve sadece oradan okunur.
 *
 * Anahtar: `cashDrawerPrinter_${companyId}_${screenId}`
 * Değer:   JSON.stringify({ id, name, pin }) veya silinmişse null
 *
 * `pin` alanı:
 *   - 'auto' (default): backend hem pin 2 hem pin 5 dener.
 *   - 'pin2': sadece pin 2 (m=0) gönderilir — XPrinter, Epson varsayılanı.
 *   - 'pin5': sadece pin 5 (m=1) gönderilir — Afanda/Aafnet, bazı Hisense.
 *
 * Kullanıcı yazıcısı + çekmecesi için doğru pin'i tek seferlik test edip
 * seçtiğinde, sonraki ödemelerde sadece o pin tetiklenir (boşa drawer komutu
 * gitmez, log gürültüsü azalır).
 */

export type CashDrawerPin = 'auto' | 'pin2' | 'pin5';

export interface CashDrawerPrinterInfo {
  id: string;
  name: string;
  /** Hangi pin'in tetikleneceği. Eski kayıtlarda yoksa 'auto' kabul edilir. */
  pin?: CashDrawerPin;
}

const KEY_PREFIX = 'cashDrawerPrinter';

export function getCashDrawerPrinterKey(
  companyId: string | null | undefined,
  screenId: string | number | null | undefined
): string | null {
  if (!companyId || screenId === null || screenId === undefined || screenId === '') {
    return null;
  }
  return `${KEY_PREFIX}_${companyId}_${screenId}`;
}

function normalizePin(value: unknown): CashDrawerPin {
  if (value === 'pin2' || value === 'pin5' || value === 'auto') return value;
  return 'auto';
}

export function loadCashDrawerPrinter(
  companyId: string | null | undefined,
  screenId: string | number | null | undefined
): CashDrawerPrinterInfo | null {
  const key = getCashDrawerPrinterKey(companyId, screenId);
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && typeof parsed.name === 'string' && parsed.name.trim()) {
      return {
        id: String(parsed.id || parsed.name),
        name: String(parsed.name),
        pin: normalizePin(parsed.pin),
      };
    }
    return null;
  } catch (e) {
    console.warn('[cashDrawerStorage] load parse hatası:', e);
    return null;
  }
}

export function saveCashDrawerPrinter(
  companyId: string | null | undefined,
  screenId: string | number | null | undefined,
  printer: CashDrawerPrinterInfo | null
): boolean {
  const key = getCashDrawerPrinterKey(companyId, screenId);
  if (!key) return false;
  try {
    if (printer && printer.name) {
      const payload: CashDrawerPrinterInfo = {
        id: String(printer.id || printer.name),
        name: String(printer.name),
        pin: normalizePin(printer.pin),
      };
      localStorage.setItem(key, JSON.stringify(payload));
      console.log(
        `💰 [cashDrawerStorage] ✓ kaydedildi (${key}): ${payload.name} [pin=${payload.pin}]`
      );
    } else {
      localStorage.removeItem(key);
      console.log(`💰 [cashDrawerStorage] temizlendi (${key})`);
    }
    return true;
  } catch (e) {
    console.warn('[cashDrawerStorage] save hatası:', e);
    return false;
  }
}
